function gaSend(
  hitType = "event",
  eventCategory = null,
  eventAction = null,
  eventLabel = null
) {
  if (typeof ga === "undefined") return;
  ga("send", hitType, eventCategory, eventAction, eventLabel);
}

export function gaEvent(
  eventCategory = null,
  eventAction = null,
  eventLabel = null
) {
  gaSend("event", eventCategory, eventAction, eventLabel);
}
